module.exports = __webpack_public_path__ + "static/media/fin1.7fce4ba3.avif";